import PropTypes from 'prop-types'

import { SHIPPING_STATUS_CODES } from '../../../common/constants'
import { useUserContext } from '../../../auth/UserProvider'
import useHomeTableActions from './useHomeTableActions'

import { LAST_INCIDENTS_TAB_VALUE, LAST_SHIPPINGS_TAB_VALUE } from './constants'
import ShippingsSummaryUI from './View'

const ShippingsSummary = ({
  tabValue,
  onChangeView,
  filters,
  shippingsData,
  states,
  isLoadingShippings,
  isLoadingShippingsStates,
  onClickResolveIncident,
}) => {
  const { statusList } = useUserContext()

  const SHIPPINGS_FILTERS_BY_STATUS_BTNS_CONFIG = [
    SHIPPING_STATUS_CODES.manifested,
    SHIPPING_STATUS_CODES.inTransit,
    SHIPPING_STATUS_CODES.delivered,
  ].map(statusCode => ({
    key: statusCode,
    label:
      statusList?.find(statusData => statusData.code === statusCode)?.name ??
      statusCode,
  }))

  const {
    selectedShippings,
    handleCheckboxChange,
    getActionsForRow,
    handleSelectAll,
    splitButtonOptions,
  } = useHomeTableActions(shippingsData?.shippings ?? [], filters, tabValue)

  const mainTabValue =
    tabValue === SHIPPING_STATUS_CODES.incidents
      ? LAST_INCIDENTS_TAB_VALUE
      : LAST_SHIPPINGS_TAB_VALUE

  const onTabChange = newTabValue => {
    if (newTabValue === LAST_INCIDENTS_TAB_VALUE) {
      onChangeView(SHIPPING_STATUS_CODES.incidents)
    } else {
      onChangeView(SHIPPING_STATUS_CODES.manifested)
    }
  }

  const onShippingsStatusChange = newShippingStatusCode => {
    onChangeView(newShippingStatusCode)
  }

  const onBackToListClick = () => {
    onChangeView(SHIPPING_STATUS_CODES.manifested)
  }

  return (
    <>
      <ShippingsSummaryUI
        shippingsFilterBtnsConfig={SHIPPINGS_FILTERS_BY_STATUS_BTNS_CONFIG}
        shippings={shippingsData?.shippings ?? []}
        states={states}
        onTabChange={onTabChange}
        onShippingsStatusChange={onShippingsStatusChange}
        onCheckboxChange={handleCheckboxChange}
        getActionsForRow={getActionsForRow}
        onSelectAllClick={handleSelectAll}
        selectedShippings={selectedShippings}
        onBackToListClick={onBackToListClick}
        actionsOptions={splitButtonOptions}
        isLoadingShippings={isLoadingShippings}
        isLoadingShippingsStates={isLoadingShippingsStates}
        mainTabValue={mainTabValue}
        onClickResolveIncident={onClickResolveIncident}
      />
    </>
  )
}

ShippingsSummary.propTypes = {
  tabValue: PropTypes.string,
  onChangeView: PropTypes.func,
  filters: PropTypes.object,
  shippingsData: PropTypes.object,
  states: PropTypes.array,
  isLoadingShippings: PropTypes.bool,
  isLoadingShippingsStates: PropTypes.bool,
  onClickResolveIncident: PropTypes.func,
}

export default ShippingsSummary
